import DateTimeParser from "./datetimeparser.peg"
import TimeParser from "./timeparser.peg"
import { pad } from 'util/string'

const S2M = 1/60
const S2H = 1/3600
const S2D = 1/86400

export function parse(string) {
  return DateTimeParser.parse(string)
}

export function parseTime(string) {
  return TimeParser.parse(string)
}

export function equals(a, b) {
  if (
    !a
    || !b
    || typeof a.getTime !== "function"
    || typeof b.getTime !== "function"
  ) return false
  return a.getTime() == b.getTime()
}

export function secondsToObject(seconds) {
  const minutes = seconds * S2M
  const hours = seconds * S2H
  const days = seconds * S2D
  return {
    hours: hours|0,
    minutes: minutes%60|0,
    seconds: seconds%60|0,
    milliseconds: (seconds%1*1000|0)
  }
}



// WEBPACK FOOTER //
// ./src/app/util/datetime.js